<template>
  <div>
    <payment-modal v-if="showPayment" :lang="lang" @closePayment="closePayment" :payment="usePayment"></payment-modal>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-4">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li :class="{ active: perPage === 10}"><a href="#" @click.prevent="changePerPage(10)">10</a></li>
              <li :class="{ active: perPage === 20}"><a href="#" @click.prevent="changePerPage(20)">20</a></li>
              <li :class="{ active: perPage === 50}"><a href="#" @click.prevent="changePerPage(50)">50</a></li>
              <li :class="{ active: perPage === 100}"><a href="#" @click.prevent="changePerPage(100)">100</a></li>
            </ul>
          </nav>
        </div>
        <div class="col-sm-4 text-center">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li>
                <router-link :to="{name: 'devices', params: {type: originType}}" @click.native="setOpenDetailId()">{{lang['return to kiosk']}} <strong>&nbsp; {{ device.name }}</strong></router-link>
                <router-link :to="{name: 'devices', params: {type: originType}}">{{ lang['Return to list']}}</router-link>
              </li>
            </ul>
          </nav>
        </div>
        <div class="col-sm-4">
          <nav aria-label="Page navigation">
            <ul class="pagination pull-right">
              <li :class="previousClass">
                <a href="#" @click.prevent="getPrevious()" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li><a>{{page}}</a></li>
              <li :class="nextClass">
                <a href="#" @click.prevent="getNext()" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="row">
        <table class="table table-hover">
          <thead>
            <th>{{lang['Date']}}</th>
            <th>{{lang['Status']}}</th>
            <th>{{lang['MicrosId']}}</th>
            <th>{{lang['Total']}}</th>
          </thead>
          <tbody>
            <tr v-for="payment in payments" :key="payment.id" :class="payment.status | paymentClass" @dblclick="showPayment = true; usePayment = payment;">
              <td>{{payment.createdAt | formatDateTime}}</td>
              <td>{{payment.status | statusDict}}</td>
              <td>{{payment.microsId}}</td>
              <td>{{payment.total | moneyFormat}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li :class="{ active: perPage === 10}"><a href="#" @click.prevent="changePerPage(10)">10</a></li>
              <li :class="{ active: perPage === 20}"><a href="#" @click.prevent="changePerPage(20)">20</a></li>
              <li :class="{ active: perPage === 50}"><a href="#" @click.prevent="changePerPage(50)">50</a></li>
              <li :class="{ active: perPage === 100}"><a href="#" @click.prevent="changePerPage(100)">100</a></li>
            </ul>
          </nav>
        </div>
        <div class="col-sm-4 text-center">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li>
                <router-link :to="{name: 'devices', params: {type: originType}}" @click.native="setOpenDetailId()">{{lang['return to kiosk']}} <strong>&nbsp; {{ device.name }}</strong></router-link>
                <router-link :to="{name: 'devices', params: {type: originType}}">{{ lang['Return to list']}}</router-link>
              </li>
            </ul>
          </nav>
        </div>
        <div class="col-sm-4">
          <nav aria-label="Page navigation">
            <ul class="pagination pull-right">
              <li :class="previousClass">
                <a href="#" @click.prevent="getPrevious()" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li><a>{{page}}</a></li>
              <li :class="nextClass">
                <a href="#" @click.prevent="getNext()" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import paymentModal from '@/components/payments/Payment'

export default {
  name: 'paymentsList',
  props: ['lang', 'device', 'originType'],
  data () {
    return {
      showPayment: false,
      page: 1,
      perPage: 10,
      payments: [],
      usePayment: ''
    }
  },
  components: {
    'payment-modal': paymentModal
  },
  watch: {
  },
  computed: {
    previousClass () {
      return (this.page === 1) ? 'disabled' : ''
    },
    nextClass () {
      return (this.payments.length !== this.perPage) ? 'disabled' : ''
    }
  },
  methods: {
    setOpenDetailId () {
      this.$store.commit('SET_OPENDETAILID', this.device.id)
    },
    changePerPage (val) {
      this.page = 1
      this.perPage = val
      this.getPayments()
    },
    getPrevious () {
      if (this.page !== 1) {
        this.page -= 1
        this.getPayments()
      }
    },
    getNext () {
      if (this.payments.length === this.perPage) {
        this.page += 1
        this.getPayments()
      }
    },
    getPayments () {
      this.$http.get('devicepaymentlog',
        {
          params:
          {
            where: {device: this.device.id},
            limit: this.perPage,
            skip: ((this.page - 1) * this.perPage),
            sort: 'createdAt DESC'
          }
        })
        .then(response => {
          return response.json()
        })
        .then(data => {
          const resultArray = []
          for (let key in data) {
            resultArray.push(data[key])
          }
          this.payments = resultArray
        })
    },
    closePayment () {
      this.showPayment = false
    }
  },
  created () {
    this.getPayments()
  }
}
</script>
<style lang="sass" scoped>
.sm-width
  width: 50px
  white-space: nowrap
.table
  td
    cursor: pointer
</style>



// WEBPACK FOOTER //
// src/components/payments/PaymentsList.vue